export default "__VITE_ASSET__CDjmhZ99__"